// /* globals MARKDOWN_TOC_DATA */
// https://babeljs.io/docs/en/babel-polyfill/
import '@babel/polyfill';
import './polyfills/console';
import { TocManager } from './toc-manager/toc-manager';

// eslint-disable-next-line dot-notation
window['IBTocManager'] = TocManager;

// new TocManager({
//   debug: true,
//   data: MARKDOWN_TOC_DATA,
//   sidebarId: 'sidebar',
//   showGroupCount: true,
//   contentFrame: {
//     id: 'contentFrame',
//     name: 'contentFrame',
//   },
// }).init();
